/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials-slider' ).find( '.slider' ).slick( {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        speed: 500,
        fade: true,
        cssEase: 'linear',
      } );

      // prev slide
      $( document ).on( 'click', '.testimonials-slider .custom-slider-nav .prev-slide', function() {
        $( this ).closest( '.slider' ).slick( 'slickPrev' );
      } );

      // next slide
      $( document ).on( 'click', '.testimonials-slider .custom-slider-nav .next-slide', function() {
        $( this ).closest( '.slider' ).slick( 'slickNext' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
